import { Directive, ElementRef, Injector, Input, Inject } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

/**
 * Expose {@link ProductPhotoComponent} to ng11.
 */
@Directive({
  selector: 'product-photo-wrapper',
})
export class ProductPhotoWrapperComponent extends UpgradeComponent {
  @Input() editable: boolean;
  @Input() source: string;
  @Input() link: string;

  constructor(
    @Inject(ElementRef) elementRef: ElementRef,
    @Inject(Injector) injector: Injector,
  ) {
    // We must pass the name of the directive as used by AngularJS to the super
    super('productPhoto', elementRef, injector);
  }
}
